import { Node } from "@tiptap/core";
import { NodeViewWrapper, ReactNodeViewRenderer } from "@tiptap/react";

import KeyTermButton from "@/view/KeyTermButton";
import { useDynamicDataProvider } from "@/view/TiptapArticleBody/extensions/DataProvider";
import { ComponentProps } from "@/view/TiptapArticleBody/TiptapArticleBody.interface";

interface KeyTermOptions {
  isArticlePreview: boolean;
  toggleVocabularySupport?: ((value: boolean) => void) | undefined;
  keyTermDataContentId?: string | undefined;
}

const Component = ({
  node,
  extension,
  editor,
}: ComponentProps<KeyTermOptions>) => {
  const { isArticlePreview, toggleVocabularySupport, keyTermDataContentId } =
    extension?.options;

  const {
    currentFontSize: fontSize,
    userProperties,
    language,
  } = useDynamicDataProvider(editor);
  const keyTermText = node.textContent;
  const { definition, id } = node.attrs;

  /**
   * Only display the key term button if not on preview mode.
   * (eg.: grading page, exportables modal)
   */
  if (!isArticlePreview) {
    return (
      <NodeViewWrapper as="span">
        <KeyTermButton
          currentFontSize={fontSize}
          dataIdentifier={id}
          isStudent={userProperties?.isStudent}
          keyTerm={keyTermText}
          keyTermDataContentId={keyTermDataContentId}
          language={language}
          termDefinition={definition}
          toggleVocabularySupport={toggleVocabularySupport}
        >
          {keyTermText}
        </KeyTermButton>
      </NodeViewWrapper>
    );
  }
  return null;
};

export const KeyTerm = Node.create<KeyTermOptions>({
  name: "keyTerm_block",
  content: "text*",
  group: "inline",
  inline: true,
  addAttributes() {
    return {
      id: {},
      definition: { default: null },
    };
  },
  addOptions() {
    return {
      isArticlePreview: false,
      toggleVocabularySupport: () => null,
      keyTermDataContentId: "",
    };
  },
  renderHTML() {
    return ["span", 0];
  },
  addNodeView() {
    return ReactNodeViewRenderer(Component);
  },
});
